import * as React from 'react'
import { Box, styled, ifProp, selectTheme } from '@creditas-ui/react'
import { node, object, string } from 'prop-types'

const propTypes = {
  component: string,
  error: object,
  className: string,
  children: node,
}

const InputHelperTextElement = styled(Box.withComponent('span'))`
  font-weight: normal;
  display: block;
  padding: ${selectTheme('input.helperText.padding')};
  font-family: ${selectTheme('input.helperText.fontFamily')};
  line-height: ${selectTheme('input.helperText.lineHeight')};
  letter-spacing: ${selectTheme('input.helperText.letterSpacing')};
  font-size: ${selectTheme('input.helperText.fontSize')};
  color: ${ifProp(
    'error',
    selectTheme('input.helperText.error.color'),
    selectTheme('input.helperText.color'),
  )};
`

const InputHelperText = ({
  component = 'span',
  error,
  className,
  children,
  ...props
}) => (
  <InputHelperTextElement
    {...props}
    as={component}
    className={className}
    error={error}
  >
    {children}
  </InputHelperTextElement>
)

InputHelperText.propTypes = propTypes

export { InputHelperText }
